

















import {Component, Vue, Watch} from 'vue-property-decorator';
import {Action, Getter} from 'vuex-class';

import 'ol/ol.css';
import Feature from 'ol/Feature';
import Map from 'ol/Map';
import Overlay from 'ol/Overlay';
import View from 'ol/View';
import Point from 'ol/geom/Point';
// @ts-ignore
import GeoJSON from 'ol/format/GeoJSON.js';
// @ts-ignore
import {Tile as TileLayer} from 'ol/layer.js';
// @ts-ignore
import {Cluster, Vector as VectorSource} from 'ol/source.js';
// @ts-ignore
import {Circle as CircleStyle, RegularShape, Fill, Stroke, Style, Text} from 'ol/style.js';
import BingMaps from 'ol/source/BingMaps.js';
// @ts-ignore
import {Vector as VectorLayer} from 'ol/layer';
import {Polygon} from 'ol/geom';

@Component({
  components: {},
})
export default class Smartmap extends Vue {
  public $refs!: {
    container: any,
    closer: any,
    content: any,
  };

  @Action('doctors/init') private initDoctors!: any;
  @Action('doctors/update') private updateDoctors!: any;
  @Action('pharmacies/init') private initPharmacies!: any;
  @Action('hospitals/init') private initHospitals!: any;
  @Action('catchments/read') private initCatchments!: any;
  @Action('map/unset') private unsetMap!: any;
  @Action('catchments/calculateQuickCatchment') private calculateQuickCatchment!: any;
  @Action('map/init') private initMap!: any;
  @Action('map/update') private updateMap!: any;
  @Action('map/addOverlay') private addOverlay!: any;
  @Action('map/addLayer') private addLayer!: any;
  @Action('common/loader/start') private startLoader!: any;
  @Action('common/loader/stop') private stopLoader!: any;

  @Getter('doctors/all') private doctors!: any;
  @Getter('doctors/supercluster') private supercluster!: any;
  @Getter('pharmacies/all') private pharmacies!: any;
  @Getter('hospitals/all') private hospitals!: any;
  @Getter('catchments/all') private catchments!: any;
  @Getter('catchments/quickCatchment') private quickCatchment!: any;
  @Getter('map/lastCatchment') private lastCatchment!: any;
  @Getter('map/map') private storeMap!: Map;
  @Getter('map/view') private view!: any;
  @Getter('map/tiles') private tiles!: any;

  @Getter('doctors/layer') private doctorLayer!: any;
  @Getter('hospitals/layer') private hospitalLayer!: any;
  @Getter('pharmacies/layer') private pharmacyLayer!: any;

  // @Setter('map/map') private map!: Map;
  private i: number = 0;

  private loading: boolean = true;

  get map() {
    return this.storeMap;
  }

  set map(val) {
    this.updateMap(val);
  }

  // private map!: Map;
  private overlay!: Overlay;

  private popupDoctors: any = [];
  private text: string = '';

  private localLastCatchment: any;

  private async mounted() {
    this.startLoader();

    await this.initMap();

    this.map = new Map({
      layers: [this.tiles, this.doctorLayer, this.pharmacyLayer, this.hospitalLayer].filter((el) => !!el),
      target: 'map',
      view: this.view,
    });

    this.overlay = new Overlay({
      element: this.$refs.container,
      autoPan: true,
    });

    this.addOverlay(this.overlay);

    this.stopLoader();

    this.loading = true;

    const promises = [
      this.initDoctors(),
      this.initPharmacies(),
      this.initHospitals(),
      this.initCatchments(),
    ];
    await Promise.all(promises);

    this.map.on('moveend', this.updateDoctors);

    this.loading = false;

    // if (this.catchments && this.catchments.features.length > 0) {
    //   const features = (new GeoJSON()).readFeatures(this.catchments);
    //   features.forEach((catchment) => {
    //     this.drawSingleCatchment(catchment);
    //   });
    // }

    this.map.on('singleclick', this.mapClickHandler);
  }

  private closePopup() {
    this.text = '';
    // @ts-ignore
    this.overlay.setPosition(null);
    this.$refs.closer.blur();
    return false;
  }

  private mapClickHandler(evt: any) {
    if (this.quickCatchment) {
      this.calculateQuickCatchment(evt);
      return;
    }

    if (!!this.overlay.getPosition()) {
      this.closePopup();
    }

    this.text = '<table class="text-small">';
    this.text += `<tr><td colspan="5000">Um mehr Informationen zu erhalten, kontaktieren Sie Ihre <a href="https:/` +
      `/arge-med.at/beratungskanzleien/autorisierte-beratungskanzleien/" target="_blank">ArgeMed Beratung!</a>` +
      `</td></tr>`;

    this.map.forEachFeatureAtPixel(evt.pixel, (feature, layer) => {
      if (feature) {
        // Scenario 1: we have a single/multiple doctors
        // Scenario 2: we have a single/multiple doctors and a single/multiple pharmacies/hospitals
        // Scenario 2: we have a single/multiple pharmacies/hospitals

        // Do not show popup for catchments
        if (feature.get('geometry') instanceof Polygon) {
          return;
        }

        const clusterId = feature.get('cluster_id');
        const features = feature.get('features');

        if (clusterId) {
          const leaves = this.supercluster.getLeaves(clusterId, 30);

          leaves.sort((a: any, b: any) => {
            let aName = '';
            let bName = '';

            if (a.properties.name && b.properties.name) {
              aName = a.properties.name;
              bName = b.properties.name;
            } else if (a.properties.familienna && b.properties.familienna) {
              aName = a.properties.familienna;
              bName = b.properties.familienna;
            }

            if (aName > bName) {
              return 1;
            } else if (aName < bName) {
              return -1;
            }
            return 0;
          });

          this.text += `<tr><td colspan="2" align="center"><b>Ärzte (${feature.get('point_count')})</b></td></tr>`;
          leaves.forEach((leave: any) => {
            if (leave.properties.name) {
              this.text += `<tr><td>Name:</td><td>${leave.properties.name}</td></tr>`;
            } else {
              this.text += `<tr><td>Titel:</td><td>${leave.properties.titel}</td></tr>`;
              this.text += `<tr><td>Vorname:</td><td>${leave.properties.vorname}</td></tr>`;
              this.text += `<tr><td>Familienname:</td><td>${leave.properties.familienna}</td></tr>`;
              this.text += `<tr><td>Fachrichtung:</td><td>${leave.properties.hauptfach}</td></tr>`;
            }
            this.text += `<tr><td>Kassa:</td><td>${this.transformKass(leave.properties.kassenstat)}</td></tr>`;
            this.text += `<tr><td>&nbsp;</td><td>&nbsp;</td></tr>`;
          });
          // We have a cluster of doctors! get cluster and display information in popup
        } else if (features) {
          if (features[0]) {
            if (features[0].get('betten')) {
              this.text += `<tr><td colspan="2" align="center"><b>Spitäler (${features.length})</b></td></tr>`;
            } else {
              this.text += `<tr><td colspan="2" align="center"><b>Apotheken (${features.length})</b></td></tr>`;
            }
          }
          // find out if it is hospital or pharmacy and add title
          features.forEach((cfeature: any) => {
            const name = cfeature.get('name');
            if (name) {
              this.text += '<tr><td>Name</td><td>' + cfeature.get('name') + '</td></tr>';
            }
          });

        } else {
          if (feature.get('name')) {
            this.text += '<h5><b>' + feature.get('name') + '</b></h5>';
            // this.text += `Straße: ${}`;
            // this.text += `Plz: ${}`;
            // this.text += `Ort: ${}`;
          } else {
            this.text += `<tr><td>Titel:</td><td>${feature.get('titel')}</td></tr>`;
            this.text += `<tr><td>Vorname:</td><td>${feature.get('vorname')}</td></tr>`;
            this.text += `<tr><td>Familienname:</td><td>${feature.get('familienna')}</td></tr>`;
          }
        }

      } else {
        this.text = '';
        // @ts-ignore
        this.overlay.setPosition(null);
      }
    });

    if (this.text !== '' && this.text !== '<table class="text-small">') {
      this.text += '</table>';
      this.$refs.content.innerHTML = this.text;
      const coord = this.map.getCoordinateFromPixel(evt.pixel);
      this.overlay.setPosition(coord);
    }
  }

  private beforeDestroy() {
    this.map.setTarget('');
    delete this.map;
    this.unsetMap();
  }

  private transformKass(kassa: string) {
    if (kassa === 'GKK') {
      return 'alle Kassen';
    }
    return kassa;
  }
}
